import { Phone, CalendarCheck, ShieldCheck, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BUSINESS } from "@/lib/config";

export default function Hero() {
  return (
    <section id="top" className="relative pt-28 lg:pt-36 pb-16 lg:pb-24 overflow-hidden" data-testid="hero-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-7">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 border border-zinc-300 bg-white rounded-sm mb-6" data-testid="hero-badge">
            <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" />
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-700">
              7/24 Açık — Acil Servis Aktif
            </span>
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter text-zinc-950 leading-[1.02]" data-testid="hero-title">
            Diyarbakır'ın{" "}
            <span className="relative inline-block">
              <span className="relative z-10">güvenilir</span>
              <span className="absolute left-0 right-0 bottom-1 h-3 bg-[#FF4500]/30 -z-0"></span>
            </span>{" "}
            kombi & tesisat ustası.
          </h1>

          <p className="mt-6 text-base lg:text-lg text-zinc-600 max-w-xl leading-relaxed" data-testid="hero-description">
            Kombi tamiratı, yedek parça, doğalgaz & sıhhi tesisat, hermetik şofben,
            radyatör petek ve elektrikli kombi hizmetlerinde{" "}
            <strong className="text-zinc-900">aynı gün müdahale</strong> ve garantili
            işçilik. Kayapınar merkezli, tüm Diyarbakır'a hizmet.
          </p>

          <div className="mt-8 flex flex-wrap gap-3">
            <a href={`tel:${BUSINESS.phone1Tel}`}>
              <Button
                size="lg"
                className="bg-[#FF4500] hover:bg-[#E63E00] text-white rounded-sm font-bold h-12 px-6 gap-2 text-base"
                data-testid="hero-call-button"
              >
                <Phone className="w-5 h-5" /> {BUSINESS.phone1}
              </Button>
            </a>
            <a href="#appointment">
              <Button
                size="lg"
                variant="outline"
                className="border-zinc-900 hover:bg-zinc-900 hover:text-white rounded-sm font-bold h-12 px-6 gap-2 text-base"
                data-testid="hero-appointment-button"
              >
                <CalendarCheck className="w-5 h-5" /> Online Randevu Al
              </Button>
            </a>
          </div>

          <div className="mt-10 grid grid-cols-3 gap-4 sm:gap-6 max-w-xl">
            {[
              { icon: Clock, label: "7/24", sub: "Acil Servis" },
              { icon: ShieldCheck, label: "Garantili", sub: "İşçilik" },
              { icon: CalendarCheck, label: "Aynı Gün", sub: "Müdahale" },
            ].map((it, i) => (
              <div
                key={i}
                className="flex flex-col items-start gap-1 p-3 border-l-2 border-[#FF4500]"
                data-testid={`hero-trust-${i}`}
              >
                <it.icon className="w-5 h-5 text-[#FF4500]" />
                <div className="text-xl font-extrabold text-zinc-950">{it.label}</div>
                <div className="text-xs uppercase tracking-widest text-zinc-500 font-semibold">
                  {it.sub}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5 relative">
          <div className="relative aspect-[4/5] overflow-hidden rounded-sm border border-zinc-200 shadow-2xl shadow-zinc-900/10">
            <img
              src="https://images.pexels.com/photos/34938442/pexels-photo-34938442.jpeg"
              alt="Diyarbakır Kombi Tamiri Uzmanı"
              className="w-full h-full object-cover"
              loading="eager"
              data-testid="hero-image"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-zinc-950/40 via-transparent to-transparent"></div>
          </div>

          {/* Floating badge */}
          <div className="absolute -bottom-4 -left-4 sm:-left-8 bg-white border border-zinc-200 rounded-sm p-4 shadow-xl max-w-[220px]" data-testid="hero-float-badge">
            <div className="flex items-baseline gap-1">
              <span className="text-3xl font-black text-zinc-950">15+</span>
              <span className="text-xs uppercase tracking-widest text-zinc-500 font-bold">yıl</span>
            </div>
            <div className="text-sm font-semibold text-zinc-700 mt-1">
              Diyarbakır'da deneyim ve binlerce memnun müşteri.
            </div>
          </div>

          <div className="hidden lg:block absolute -top-4 -right-4 bg-[#FF4500] text-white p-4 rounded-sm shadow-xl" data-testid="hero-float-cta">
            <div className="text-xs uppercase tracking-widest font-bold opacity-80">Acil mi?</div>
            <div className="font-black text-lg">Şimdi Ara</div>
          </div>
        </div>
      </div>
    </section>
  );
}
